module.exports = __webpack_public_path__ + "static/img/dancewr.35849f5a.webp";